import { defineStore } from 'pinia';
import UserService from '@/services/user';
import { LOCALSTORAGE_ACCESS_TOKEN, LOCALSTORAGE_REFRESH_TOKEN  } from '@/api-config';

export const useAuthStore = defineStore('auth', {
  state: () => ({
    currentUser: null,
    token: localStorage.getItem(LOCALSTORAGE_ACCESS_TOKEN) || null,
  }),
  getters: {
    loggedIn() {
      return !!this.token;
    },
  },
  actions: {
    validate() {
      if (!this.token) {
        return Promise.resolve({})
      }

      UserService.getUserData().then(res => {
        this.setUser(res.data);
        return Promise.resolve(res.data);
      })
    },

    setUser(user) {
      this.currentUser = user;
    },
    logOut() {
      this.setUser(null);
      this.token = null;

      localStorage.removeItem(LOCALSTORAGE_ACCESS_TOKEN);
      localStorage.removeItem(LOCALSTORAGE_REFRESH_TOKEN);
    },

    login({ username, password }) {
      return new Promise((resolve, reject) => {
        UserService.auth(username, password)
          .then(async (res) => {
            const token = res.data.token;
            const refreshToken = res.data.refreshToken;

            localStorage.setItem(LOCALSTORAGE_ACCESS_TOKEN, token);
            localStorage.setItem(LOCALSTORAGE_REFRESH_TOKEN, refreshToken);
            this.token = token;

            await this.validate();

            resolve(res);
          })
          .catch((err) => {
            localStorage.removeItem(LOCALSTORAGE_ACCESS_TOKEN);
            localStorage.removeItem(LOCALSTORAGE_REFRESH_TOKEN);
            reject(err.response.data ? err.response.data.msg : err);
          });
      });
    },
  },
});
